import { render, staticRenderFns } from "./SelectServiceType.vue?vue&type=template&id=f5e870da"
import script from "./SelectServiceType.vue?vue&type=script&lang=js"
export * from "./SelectServiceType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports